import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { DesignerVisualStyle } from '../visual-style/models/designer-visual-style.model';

export const DesignerViewActions = createActionGroup({
  source: 'Designer View',
  events: {
    'Designer Entered': props<{ visualStyle: DesignerVisualStyle }>(),
    'Designer Exited': emptyProps(),
  },
});
